import clsx from 'clsx';

import { BadgeProps } from './Badge';
import badgeClasses from './Badge.module.css';

export const DefaultBadgeProps: Partial<BadgeProps> = {
  color: 'primary',
  size: 'md',
  variant: 'filled',
  radius: 'lg'
};

export const BadgeOverrideClassNames = (props: BadgeProps) => {
  return {
    root: clsx(badgeClasses.root, {
      [badgeClasses.rootWithoutBorder]: props.withBorder === false,
      [badgeClasses.xs]: props.size === 'xs',
      [badgeClasses.sm]: props.size === 'sm',
      [badgeClasses.md]: props.size === 'md',
      [badgeClasses.lg]: props.size === 'lg',
      [badgeClasses.xl]: props.size === 'xl',
      [badgeClasses.primary]: props.color === 'primary',
      [badgeClasses.secondary]: props.color === 'secondary',
      [badgeClasses.success]: props.color === 'success',
      [badgeClasses.danger]:
        props.color === 'pink' || props.color === 'red' || props.color === 'danger'
    }),
    section: badgeClasses.sectionStyles
  };
};
